import React, { useEffect, useState } from 'react';
import { ZODIAC_SIGNS } from '../constants/zodiac';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const LandingPage = () => {
  const [stars, setStars] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const generateStars = () => {
      const newStars = [];
      for (let i = 0; i < 100; i++) {
        newStars.push({
          id: i,
          left: Math.random() * 100,
          top: Math.random() * 100,
          size: Math.random() * 3,
          animationDelay: Math.random() * 3
        });
      }
      setStars(newStars);
    };

    generateStars();
  }, []);

  const handleZodiacClick = (sign) => {
    navigate(`/horoscope/${sign.name.toLowerCase()}`);
  };

  return (
    <div className="container">
      <div className="astrology-bg"></div>
      <div className="stars">
        {stars.map((star) => (
          <div
            key={star.id}
            className="star"
            style={{
              left: `${star.left}%`,
              top: `${star.top}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              animationDelay: `${star.animationDelay}s`
            }}
          />
        ))}
      </div>

      <header className="header">
        <h1 className="title">Astra Connect</h1>
        <p className="subtitle">Discover Your Cosmic Destiny</p>
      </header>

      <main>
        <div className="zodiac-grid">
          {ZODIAC_SIGNS.map((sign, index) => (
            <div
              key={sign.name}
              className="zodiac-card"
              onClick={() => handleZodiacClick(sign)}
              style={{
                animationDelay: `${index * 0.1}s`,
                borderLeftColor: sign.color,
                borderLeftWidth: '4px'
              }}
            >
              <span className="zodiac-symbol" style={{ color: sign.color }}>
                {sign.symbol}
              </span>
              <h2 className="zodiac-name">{sign.name}</h2>
              <p className="zodiac-date">{sign.dateRange}</p>
              <span className="zodiac-element">{sign.element} Sign</span>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
